export default {
  scoreBox: {
    fiinTradeRank: 'FiinTrade Rank',
    basicMaterials: 'Basic Materials',
    score: 'Score',
    value: 'Value',
    growth: 'Growth',
    momentum: 'Momentum',
    vgm: 'VGM',
  },
  rankingTooltip: {
    oneLine: 'Stock ranking for all stocks in sectors and',
    twoLine: 'within VN30, VNMidcap, VNSmall groups',
  },
  scoreTooltip: {
    oneLine: 'Stock score for all stocks in sectors and',
    twoLine: 'within VN30, VNMidcap, VNSmall groups',
  },
  LOWEST: 'LOWEST',
  HIGHEST: 'HIGHEST',
};
